import Pubnub from 'pubnub';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../..';
import { getErrorText } from './helpers';

type Params = { roomId: Array<string> };
type Response = Pubnub.HereNowResponse;

export const getActiveUsers = createAsyncThunk<Response, Params, { rejectValue: string }>(
  'pubnub/getActiveUsers',
  async (data, { rejectWithValue, getState }) => {
    try {
      const pubnubReducer = (getState() as RootState).pubnub;

      if (pubnubReducer.pubnub) {
        const result = await pubnubReducer.pubnub.hereNow({
          channels: data.roomId,
          includeUUIDs: false,
        });

        return result;
      } else {
        throw new Error('PubnubInstanceIsNull');
      }
    } catch (e) {
      return rejectWithValue(getErrorText(e as Error));
    }
  },
);
